import { useSelectorKiosk } from "./useSelectorKiosk";

const useDefaultMode = () => {
    const selector = useSelectorKiosk(state => state.defaultMode)
    return selector;
}

export default useDefaultMode;